import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../../store/actions/AuthActions';
import AuthLayout from './auth/AuthLayout';
import SocialAuth from '../components/Auth/SocialAuth';
import { Button, Field, Input } from '../ui';
import { useBranding } from '../../context/BrandingContext';

const StreamLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { signupAllowed } = useBranding();

  const [form, setForm] = useState({ username: '', password: '' });
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await dispatch(loginUser(form.username, form.password));
      if (result.success) {
        navigate(result.hasSubscription === false ? '/pricing' : '/stream-dashboard');
      } else if (result.needsPhoneVerification) {
        navigate('/verify-phone', {
          state: { phone: result.phone, userId: result.userId, username: form.username },
        });
      } else {
        setError(result.error || 'Login failed');
      }
    } catch {
      setError('An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Welcome back"
      title="Sign in to your console"
      subtitle="Manage your streams, playlists and analytics."
      footer={
        signupAllowed ? (
          <>
            New to Teve?{' '}
            <Link to="/register" className="tw-font-semibold tw-text-brand">Create an account</Link>
          </>
        ) : null
      }
    >
      {error && (
        <div className="tw-mb-4 tw-rounded-xl tw-border tw-border-live/30 tw-bg-live/10 tw-px-4 tw-py-3 tw-text-sm tw-text-live">
          {error}
        </div>
      )}

      <form onSubmit={submit} className="tw-space-y-4">
        <Field label="Username or email">
          <Input
            name="username"
            value={form.username}
            onChange={set('username')}
            placeholder="you@example.com"
            autoComplete="username"
            required
          />
        </Field>

        <Field label="Password">
          <div className="tw-relative">
            <Input
              type={showPw ? 'text' : 'password'}
              name="password"
              value={form.password}
              onChange={set('password')}
              placeholder="Enter your password"
              autoComplete="current-password"
              className="tw-pr-10"
              required
            />
            <button
              type="button"
              onClick={() => setShowPw((s) => !s)}
              className="tw-absolute tw-right-3 tw-top-1/2 tw--translate-y-1/2 tw-text-content-faint hover:tw-text-content"
              tabIndex={-1}
            >
              <i className={`fa-solid ${showPw ? 'fa-eye-slash' : 'fa-eye'}`} />
            </button>
          </div>
        </Field>

        <Button type="submit" size="lg" className="tw-w-full" disabled={loading}>
          {loading ? <><i className="fa-solid fa-spinner fa-spin" /> Signing in…</> : 'Sign In'}
        </Button>
      </form>

      <SocialAuth
        onResult={(r) => {
          if (r.success) navigate(r.hasSubscription === false ? '/pricing' : '/stream-dashboard');
          else if (r.error) setError(r.error);
        }}
      />
    </AuthLayout>
  );
};

export default StreamLogin;
